import { STATUS_REASON } from '@constants/limits';
import { CYLINDER_STATUS_DIALOG as T } from '@locales/id/cylinders';
import type { Cylinder, CylinderStatus } from '@lib/api';

/** A status a person sets (never DESTROYED: only a failed test at a Bengkel Uji does). */
export type ManualStatus = Exclude<CylinderStatus, 'DESTROYED'>;
import type { IconName } from '@ui';

/** In the order the menu offers them: back to Aktif first, then out of circulation. */
const ORDER: ManualStatus[] = ['ACTIVE', 'DAMAGED', 'WITHDRAWN', 'LOST'];

/**
 * The status changes offered for a cylinder, by the server's distribution rules (it decides in the end): none while
 * it is on the road or on a Surat Jalan being loaded; only "hilang" while it did not arrive (back to Aktif goes
 * through Tandai ditemukan); none while a household holds it; never for a destroyed cylinder (final); any other
 * status while it sits at a Titik Distribusi. The status never moves it.
 */
export function statusTargets(c: Pick<Cylinder, 'status' | 'positionStatus' | 'currentShipmentId'>): ManualStatus[] {
  if (c.status === 'DESTROYED') return [];
  if (c.positionStatus === 'IN_TRANSIT' || c.positionStatus === 'WITH_CONSUMER') return [];
  if (c.positionStatus === 'MISSING') return c.status === 'LOST' ? [] : ['LOST'];
  if (c.currentShipmentId !== null) return [];
  return ORDER.filter((s) => s !== c.status);
}

export const STATUS_ICON: Record<ManualStatus, IconName> = { ACTIVE: 'refresh', DAMAGED: 'warn', WITHDRAWN: 'minus', LOST: 'search' };

/** Why the typed reason cannot be sent yet (trimmed, as the server counts it), or null. `required`: the empty case. */
export function reasonProblem(reason: string, required: string = T.reasonRequired): string | null {
  const n = reason.trim().length;
  if (!n) return required;
  if (n < STATUS_REASON.min) return T.reasonShort(STATUS_REASON.min);
  return null;
}
